import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import arrowLink from "../images/arrowLink.svg";
// styling
import { linkFlex, navFlex } from "./GlobalStyle";
import styled from "styled-components";

function Topnav() {
  const [clockState, setClockState] = useState();

  useEffect(() => {
    setInterval(() => {
      const date = new Date();
      setClockState(date.toLocaleTimeString());
    }, 1000);
  }, []);
  return (
    <motion.div
      initial={{ y: -100 }}
      animate={{ y: 0, zIndex: 1000 }}
      transition={{
        type: "spring",
        stiffness: 400,
        damping: 20,
      }}
    >
      <TopNavStyle>
        {/* name and title  */}
        <div className="name-and-title">
          <div>
            Samuel Afolabi<span className="touch">| developer</span>
          </div>
          {/* <div> dev</div> */}
          <div className="job-roles"> Developer | Designer</div>
        </div>
        {/* name and title  */}
        <motion.div
          className="time"
          initial={{ y: -100 }}
          animate={{ y: 0 }}
          transition={{
            type: "spring",
            stiffness: 400,
            damping: 20,
            delay: 1,
          }}
        >
          {clockState}
        </motion.div>
        {/* pages  */}
        <div className="pages">
          <Link to={"/works"} className="link">
            <div>Works</div>
            <img src={arrowLink} alt="my-works" />
          </Link>
          <a
            href="https://samuelafolabi.hashnode.dev/"
            target="_blank"
            className="link reduce"
          >
            <div>technical write-ups </div>
            <img src={arrowLink} alt="about-me" />
          </a>
        </div>
        {/* pages  */}
      </TopNavStyle>
    </motion.div>
  );
}

export default Topnav;

// styling
export const TopNavStyle = styled.div`
  @media (hover: none) {
    .name-and-title {
      width: 100vw !important;
      display: flex;
      margin: 5px 0 0 10px;
    }
  }

  ${navFlex}
  .link {
    ${linkFlex}
    justify-content: flex-end;
    color: inherit;
  }
  .reduce {
    margin-top: -6px;
  }
  .time {
    width: calc(100% / 3);
    text-align: center;
  }
  .name-and-title {
    width: calc(100% / 3);
  }
  .pages {
    width: calc(100% / 3);
  }
`;
